import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  Modal,
  Drawer,
  notification,
  Row,
  Select,
  Table,
  Tooltip
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { PureComponent } from 'react'

import { connect } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { getPushPathWrapper, getUrlParams } from '../../../routes'

import { Editor } from 'react-draft-wysiwyg'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {
  ArticleTypeList,
  chooseEmailModalFxn,
  Countries,
  CustomCkEditor,
  DesignationList,
  InputBox,
  mentionsFeeds,
  NotificationBox,
  ProcessList, YearArr, YearArr2, paymentModeList, copiesList
} from '../../../components/_utils/appUtils'
import { CountriesList, JournalList } from '../../journals/actions'
import { singleOnlineSubmission } from '../../onlineSubmission/actions'
import { addMember, checkMemberEmails } from '../../members/actions'
import { addSubscriptionActivityFxn } from '../action'
import { getGroupedSubscription, journalsAjaxList } from '../../subscription/actions'

@Form.create()
class AddGeneralSubscriptionDrawer extends PureComponent {
  state = {
    name: '',
    journalListArr: [],
    email: '',
    state: '',
    totalAmount:'',
    journals: [],
    journalName:'',
    country: '',
    city: '',
    subscribedBy: '',
    yearOptions: [],
    pincode: '',
    pageNumber: '',
    endUserAddress: '',
    copies: '',
    designation: '',
    contactPerson: '',
    agencyName: '',
    subscriptionData: {},
    journalList: [],
    multipleJournals:[],
    amountDetails:[],
    distinctYears:[]
  }
  paymentDetails = {
    receivedDate: '',
    modeOfPayment: '',
    amount: '',
    year: ''

  }

  constructor(props) {
    super(props)

  }

  resetFormData = () => {
    const { dispatch, form } = this.props
    form.setFieldsValue({
      journals: [],
      name: '',
      email: '',
      country: '',
      state: '',
      city: '',
      pincode: '',
      subscribeBy: '',
      address: '',
      mobile: '',
      instituteName: '',
      instituteContactPerson: '',
      instituteContactNo: '',
      instituteAddress: '',
      copies: ''
    })
  }
  handleSubmit = e => {
    const { dispatch, form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        valData.amountDetails = this.state.amountDetails
        valData.totalAmount = this.state.totalAmount
        valData.journals = this.state.journals

        let { success, message } = await dispatch(addSubscriptionActivityFxn(valData))

        if (success) {
          notification.success({
            message: message
          })
          this.resetFormData()
          this.props.onClose()
          this.setState({
            name: '',
            email: '',
            country: '',
            state: '',
            city: '',
            pincode: '',
            subscriptionBy: '',
            journals: '',
            pageNumber: '',
            endUserAddress: '',
            designation: '',
            contactPerson: '',
            agencyName: '',
            copies: ''
          })
        }
      }
    })

  }


  componentDidMount() {

    this.loadJournalList()
    this.apiGroupedSubscription()
    this.journalAjax()
    let data = getUrlParams('article.onlineSubmission', this.props.pathname)
    if (!!data) {
      let { id } = data
      this.setFormValuesFxn(id)
    }
  }


  events = {
    removeStateCountry: (index) => {
      let cloneArr = _.clone(this.state.amountDetails);
      cloneArr.splice(index, 1);
      const { year } = this.state;

      const { total, amountDetails } = this.calculateTotalAmount(cloneArr);

      this.setState({
        amountDetails,
        totalAmount: total
      });
    }
  }
  calculateTotalAmount = (multipleJournals) => {
    const { subscriptionData } = this.state;
    let total = 0;
    const amountDetails = [];
    const journalArray = [];

    if (!multipleJournals || multipleJournals.length === 0) {
      return { total, amountDetails };
    }
    multipleJournals.forEach(item => {
      const { journals, journalName, copies, year } = item;
      const journalSubs = subscriptionData[journals] || [];
      const sub = journalSubs.find(s => s.year === year);

      if (sub) {
        const copiesCount = parseInt(copies, 10) || 1;
        const totalForSub = sub.priceInInr * copiesCount;

        total += totalForSub;
        amountDetails.push({
          journalId: journals,
          journalName,
          copies: copiesCount,
          priceInInr: sub.priceInInr,
          totalForSub,
          year
        });
        journalArray.push(journals)
      }
    });

    this.setState({journals:journalArray})
    return { total, amountDetails };
  };
  loadJournalList = async () => {
    const { dispatch, form } = this.props
    let { data } = await JournalList()
    this.setState({ journalListArr: data })
    form.setFieldsValue({ enterDate: moment() })
  }

  journalAjax = async () => {
    let { dispatch } = this.props
    let { data } = await dispatch(journalsAjaxList())
    this.setState({ journalList: data })
  }
  apiGroupedSubscription = async () => {
    let result = await getGroupedSubscription()
    const data = result.data || {};

    const allItems = Object.values(data).flat();

    const allYears = allItems.map(item => item.year);

    const distinctYears = [...new Set(allYears)];
    this.setState({
      subscriptionData: data,
      distinctYears:distinctYears
    });

  }

  chooseDocument = e => {
    let { name, files } = e.target
    if (files && files.length) {
      this.setState({ [name]: files[0] })
    }

  }
  async AddSubscriptionDetails() {
    const {
      form: { getFieldValue, setFieldsValue }
    } = this.props;

    let journals = getFieldValue("journals");
    let copies = getFieldValue("copies");
    let year = getFieldValue("year");

    if (!journals) {
      notification.error({ message: "Please choose Journal Name." });
      return;
    }
    if (!copies) {
      notification.error({ message: "Please select copies" });
      return;
    }
    if (!year) {
      notification.error({ message: "Please choose Year." });
      return;
    }

    const journalObj = this.state.journalList.find(j => j._id === journals);

    let newItem = {
      journals,
      copies,
      year,
      journalId: journalObj._id,
      journalName: journalObj.name
    };
    let clone = _.cloneDeep(this.state.amountDetails);

    const existIndex = clone.findIndex(
      item => item.journals === journals && item.year === year
    );

    if (existIndex !== -1) {
      clone[existIndex].copies = Number(clone[existIndex].copies) + Number(copies);

    } else {
      clone.push(newItem);
    }
    this.setState({ amountDetails: clone });

    setFieldsValue({
      journals: undefined,
      copies: undefined
    });

    const { total,amountDetails } = this.calculateTotalAmount(clone);
    this.setState({ totalAmount: total });

  }

  render() {
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
      loading
    } = this.props
    const { edit, journalListArr, lastArticleNo, subscriptionData } = this.state
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      }
    }


    const inputSchma = {
      fields: [
        {
          label: 'Name',
          key: 'name',
          required: true,
          placeholder: 'Name'
        },
        {
          label: 'Email',
          key: 'email',
          required: true,
          placeholder: 'email'
        },
        {
          label: 'Mobile',
          key: 'mobile',
          required: true,
          placeholder: 'Mobile'
        },
        {
          label: 'Address',
          key: 'address',
          required: true,
          placeholder: 'Address'
        },
        {
          label: 'Pincode',
          key: 'pincode',
          required: true,
          placeholder: 'pincode'
        },

        {
          label: 'Country',
          key: 'country',
          required: true,
          showSearch: true,
          options: Countries,
          keyAccessor: x => x.name,
          valueAccessor: x => x.name,
          placeholder: 'Country',
          type: 'select',
          onChange: val => {
            setFieldsValue({ country: val })

          }
        },
        {
          label: 'State',
          key: 'state',
          required: true,
          placeholder: 'State'
        },
        {
          label: 'City',
          key: 'city',
          required: true,
          placeholder: 'City'
        },
        {
          label: 'Page Number',
          key: 'pageNumber',
          required: true,
          placeholder: 'Page Number'
        },
        {
          label: 'Subscribe By',
          key: 'subscribeBy',
          required: true,
          type: 'select', options: ['Institute', 'Person'],
          onChange: val => {
            setFieldsValue({ subscribeBy: val })
          }
        },
        {
          label: 'Contact Person',
          key: 'contactPerson',
          required: true,
          placeholder: 'Contact Person',
          hidden: !(getFieldValue('subscribeBy') == 'Person')
        },
        {
          label: 'Designation',
          key: 'designation',
          required: true,
          placeholder: 'Designation',
          hidden: !(getFieldValue('subscribeBy') == 'Person')
        },
        {
          label: 'Agency Name',
          key: 'agencyName',
          required: true,
          placeholder: 'Agency Name',
          hidden: !(getFieldValue('subscribeBy') == 'Person')
        },
        {
          label: 'End User Address',
          key: 'endUserAddress',
          placeholder: 'End User Address'
        },



        {
          label: 'Institute Name',
          key: 'instituteName',
          placeholder: 'Institute Name',
          hidden: !(getFieldValue('subscribeBy') == 'Institute')

        },
        {
          label: 'Institute Contact Person',
          key: 'instituteContactPerson',
          placeholder: 'Institute Contact Person',
          hidden: !(getFieldValue('subscribeBy') == 'Institute')

        },
        {
          label: 'Institute Address',
          key: 'instituteAddress',
          placeholder: 'Institute Address',
          hidden: !(getFieldValue('subscribeBy') == 'Institute')

        },
        {
          label: 'Institute Contact No',
          key: 'instituteContactNo',
          placeholder: 'Institute Contact No',
          hidden: !(getFieldValue('subscribeBy') == 'Institute')

        },
        {
          label: 'Year',
          key: 'year',
          type: 'select',
          options:this.state.distinctYears,
          allowClear: true,
          placeholder: 'Year',
          keyAccessor: x => x,
          valueAccessor: x => x,
          onChange: (val) => {
            setFieldsValue({ year: val })
          }

        },

      ],
      multiFields: [
        {
          label: 'Journal of Interest',
          key: 'journals',

          showSearch: true,
          options: this.state.journalList,
          keyAccessor: x => x._id,
          valueAccessor: x => x.name,
          placeholder: 'Journal',
          type: 'select',
          onChange: val => {
            setFieldsValue({ journals: val })
            const selectedJournalId = val && val
            const relatedYears = subscriptionData[selectedJournalId] && subscriptionData[selectedJournalId].map(item => item.year) || []
            this.setState({ yearOptions: relatedYears })

          }

        },
        {
          label: 'Copies',
          key: 'copies',

          type: 'select', options: copiesList,
          onChange: val => {
            setFieldsValue({ copies: val })
          }
        },



        {
          key: 'add',
          span: 4,
          customField: (
            <InputBox title={'Add'} >
              <a className='btn ' type='primary'
                 onClick={() => {
                   this.AddSubscriptionDetails()
                 }}
                 style={{ backgroundColor: '#1556bc', textColor: 'white', color: 'white',marginBottom:'6px' }}>
                ADD
              </a>
            </InputBox>
          )
        }
      ]



    }
    const assignColumns = [
      {
        title: 'Journal Name',
        key: 'journalName',
        dataIndex: 'journalName'
      },
      {
        title: 'Copies',
        key: 'copies',
        dataIndex: 'copies'
      },


      {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        render: (item, record, index) => {
          return (
            <Icon type={'close'}
                  style={{ color: 'red' }}
                  onClick={() => {
                    this.events.removeStateCountry(index)
                  }} />
          )
        }
      }

    ]

    return (
      <Drawer
        title={'Add General Subscription'}
        width={'45%'}
        visible={this.props.visible}
        maskClosable={true}
        placement='right'
        onClose={this.props.onClose}>
        <Card bordered={true}>
          <Form
            onSubmit={this.handleSubmit}
            hideRequiredMark
            className={'inputForm'}>
            <Row gutter={16}>
              <Col span={24}>
                <Card bordered={true}>
                  <Row gutter={16}>
                    {inputSchma.fields.map((item, key) => {
                      return (
                        !item.hidden && (
                          <Col
                            span={item.span ? item.span : 8}
                            md={item.span ? item.span : 8}
                            sm={12}
                            xs={24}
                            key={key}>
                            {item.customField ? (
                              item.customField
                            ) : (
                              <GetEachFormFields
                                item={item}
                                getFieldDecorator={getFieldDecorator}
                                formItemLayout={formItemLayout}
                              />
                            )}
                          </Col>
                        )
                      )
                    })}
                  </Row>
                  <Row gutter={16}>
                    {inputSchma.multiFields.map((item, key) => {
                      return (
                        !item.hidden && (
                          <Col
                            span={item.span ? item.span : 6}
                            md={item.span ? item.span : 6}
                            sm={8}
                            xs={24}
                            key={key}>
                            {item.customField ? (
                              item.customField
                            ) : (
                              <GetEachFormFields
                                item={item}
                                getFieldDecorator={getFieldDecorator}
                                formItemLayout={formItemLayout}
                              />
                            )}
                          </Col>
                        )
                      )
                    })}
                  </Row>
                </Card>
              </Col>
              <Col span={24} style={{ marginTop: '10px' }}>
                <Row gutter={16}>
                  <Table dataSource={this.state.amountDetails}
                         className={'table table-bordered'}
                         bordered={true} size={'small'}
                         pagination={false} columns={assignColumns} />
                </Row>
              </Col>
            </Row>
            {this.state && this.state.totalAmount  && (
              <>

                <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '16px 0', marginTop: '0px' }}>
                  <div style={{ padding: '12px', background: '#f5f5f5', borderRadius: '4px' }}>

                    <p style={{ margin: 0, fontWeight: 'bold' }}>
                      Total Amount - INR {this.state && this.state.totalAmount}
                    </p>
                  </div>
                </div>
              </>
            )}
            <Form.Item style={{ marginTop: 32 }}>
              <Button type='primary' htmlType='submit'>
                SUBMIT
              </Button>
            </Form.Item>
          </Form>


        </Card>
      </Drawer>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(mapStateToProps,
  mapDispatchToProps
)(AddGeneralSubscriptionDrawer)
